document.addEventListener("DOMContentLoaded", () => {
    const wrapperClass = "custom_artwork_popup";

    if (!document.querySelector(`.${wrapperClass}`)) {
        const wrapper = document.createElement("div");
        wrapper.className = wrapperClass;
        document.body.appendChild(wrapper);

        const observer = new MutationObserver(() => {
            const el = document.querySelector("#tee-artwork-form");

            if (el && !wrapper.contains(el)) {
                wrapper.appendChild(el);
                console.log("Artwork found and wrapped");

                // Create the close button inside artwork form
                const closeButton = document.createElement("span");
                closeButton.className = "close_artwork_popup";
                el.appendChild(closeButton);

                closeButton.addEventListener("click", () => {
                    if (wrapper.classList.contains("active_popup")) {
                        wrapper.classList.remove("active_popup");
                        console.log("active_popup removed");
                    }
                });

                // Move product buttons into popup
                const productButtons = document.querySelector("product-form.product-form");
                if (productButtons && !wrapper.contains(productButtons)) {
                    wrapper.appendChild(productButtons);
                    console.log("Moved product-form.product-form into popup");
                }

                // ⭐ ADD-TO-CART BUTTON LOGIC
                setupAddToCartCloseLogic(wrapper);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Open popup when variant label clicked
    document.body.addEventListener("click", (e) => {
        const label = e.target.closest(".product-form__input--pill input[type=radio] + label");
        if (label) {
            const wrapper = document.querySelector(".custom_artwork_popup");
            if (wrapper && !wrapper.classList.contains("active_popup")) {
                wrapper.classList.add("active_popup");
            }
        }
    });
});


// ⭐ Function to handle Add-to-Cart → Wait for SlideCart → Close popup
function setupAddToCartCloseLogic(wrapper) {
    const addToCartBtn = document.querySelector(".product-form__buttons .product-form__submit");

    if (!addToCartBtn) {
        console.warn("Add to cart button not found");
        return;
    }

    addToCartBtn.addEventListener("click", () => {
        // Check every 100ms until SlideCart is open
        const checkInterval = setInterval(() => {
            const slideCart = document.querySelector("#slidecarthq .slidecarthq");
            const isOpen = slideCart && slideCart.classList.contains("open");

            if (isOpen) {
                wrapper.classList.remove("active_popup");
                console.log("SlideCart opened → popup closed");

                clearInterval(checkInterval);
            }
        }, 100);

        // Safety timeout (stop after 5 seconds)
        setTimeout(() => clearInterval(checkInterval), 5000);
    });
}


// Default variant selection
document.addEventListener("DOMContentLoaded", () => {
    const defaultVariant = document.querySelector(
        'input[type="radio"][value="The Ultimate Pet Lover"]'
    );
    if (defaultVariant && !defaultVariant.checked) {
        defaultVariant.checked = true;
        defaultVariant.dispatchEvent(new Event("change", { bubbles: true }));
    }
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".bfs_ups_bar");

  if (!section) return;

  const slider = section.querySelector("ul.multicolumn-list.slider");

  if (!slider) return;

  // Mobile only
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  if (!isMobile) return;

  let slideWidth =
    slider.querySelector(".multicolumn-list__item")?.clientWidth || 200;

  let currentScroll = 0;

  const autoScroll = () => {
    if (!document.body.contains(slider)) return;

    currentScroll += slideWidth;

    // Loop when reaching end
    if (currentScroll >= slider.scrollWidth - slider.clientWidth) {
      currentScroll = 0;
    }

    slider.scrollTo({
      left: currentScroll,
      behavior: "smooth",
    });
  };

  // Auto-scroll every 3 seconds
  setInterval(autoScroll, 3000);
});
